module.exports = __webpack_public_path__ + "static/media/4.9.a4764741.png";